// Availability.js
import axiosInstance from '@/lib/axios';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  const tokenType = localStorage.getItem('tokenType');
  return {
    'Authorization': `${tokenType} ${token}`,
    'Content-Type': 'application/json',
  };
};

export async function eventPOST(data) {
  try {
    const response = await axiosInstance.post('/users/events', data);
    return response.data;
  } catch (error) {
    if (error.response) throw new Error(error.response.data || 'Request failed');
    throw new Error(error.message);
  }
}

export async function eventGET() {
  try {
    const response = await axiosInstance.get('/users/events');
    return response.data;
  } catch (error) {
    if (error.response) throw new Error(error.response.data || 'Request failed');
    throw new Error(error.message);
  }
}

export async function myEventsGET() {
  try {
    const response = await axiosInstance.get('/users/events/me');
    return response.data;
  } catch (error) {
    if (error.response) throw new Error(error.response.data || 'Request failed');
    throw new Error(error.message);
  }
}

export async function eventPATCH(data) {
  try {
    const payload = {
      id: data.id,
      event_name: data.event_name,
      event_date: data.event_date,
      time_range: data.time_range,
      description: data.description,
      venue: data.venue,
      max_participants: data.max_participants,
      permission: data.permission,
      address: data.address,
    };

    const response = await axiosInstance.patch('/users/events', payload);
    return response.status === 204 ? null : response.data;
  } catch (error) {
    if (error.response) {
      // Extract the string from detail
      const message = error.response.data?.detail || 'Request failed';
      throw new Error(message); // <-- now it's a string
    }
    throw new Error(error.message);
  }
}


export async function eventDELETE(data) {
  try {
    const response = await axiosInstance.delete(`/users/events/${data.id}`, { data });
    return response.status === 204 ? null : response.data;
  } catch (error) {
    if (error.response) throw new Error(error.response.data || 'Request failed');
    throw new Error(error.message);
  }
}